import { render } from "./BudgetSheets.vue?vue&type=template&id=1074ae48"
import script from "./BudgetSheets.vue?vue&type=script&lang=js"
export * from "./BudgetSheets.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__